import { render } from "./CommentsIntroHeader.vue?vue&type=template&id=3a102ce4&scoped=true"
import script from "./CommentsIntroHeader.vue?vue&type=script&lang=js"
export * from "./CommentsIntroHeader.vue?vue&type=script&lang=js"

import "./CommentsIntroHeader.vue?vue&type=style&index=0&id=3a102ce4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a102ce4"]])

export default __exports__